// extracted by mini-css-extract-plugin
module.exports = {"bottomFixed":"TotalPriceLabel_bottomFixed__22Ucs","orderTitle":"TotalPriceLabel_orderTitle__1isBH"};